<template>
  <span class="col-form-label error col-md-12">
    <ul >
      <li v-for="(error, index) in errors" :key="index">
         {{ error }}
      </li>
    </ul>
  </span>
</template>

<script>
export default {
  name: 'form-error',
  props: {
    errors: Array
  }
}
</script>

<style scoped>
.error {
  color: red;
}
span {
  display: inline-block;
}
</style>